/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { colors } from '../../../shared/theme/colors';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { SoftPressable } from '../../../shared/ui/SoftPressable';
import {
  GASTRONOMY_STOCK_MODE_OPTIONS,
  type GastronomyStockMode,
} from '../../../onboarding/application/gastronomyStockMode';

type Props = {
  selectedMode: GastronomyStockMode;
  onSelectMode: (mode: GastronomyStockMode) => void;
  disabled?: boolean;
};

export function GastronomyStockModeStepPanel({ selectedMode, onSelectMode, disabled }: Props) {
  return (
    <View style={styles.wrap}>
      {GASTRONOMY_STOCK_MODE_OPTIONS.map((opt) => {
        const active = opt.mode === selectedMode;
        return (
          <SoftPressable
            key={opt.mode}
            disabled={disabled}
            onPress={() => onSelectMode(opt.mode)}
            style={[styles.card, active && styles.cardActive]}
            accessibilityRole="radio"
            accessibilityState={{ selected: active }}
          >
            <Text style={[styles.title, active && styles.titleActive]}>{opt.title}</Text>
            <Text style={styles.description}>{opt.description}</Text>
          </SoftPressable>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: spacing.md },
  card: {
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 12,
    padding: spacing.md,
    backgroundColor: ticketColors.paper,
  },
  cardActive: {
    borderColor: ticketColors.brandPrimary,
    backgroundColor: ticketColors.brandSoft,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.textPrimary,
    marginBottom: spacing.xs,
  },
  titleActive: { color: ticketColors.brandInk },
  description: {
    fontSize: 14,
    lineHeight: 20,
    color: colors.textSecondary,
  },
});
